const IDENTIFIED_VIA_FIELD_NAMES = {
  UPPERCASE: 'IDENTIFIEDVIA',
  LOWERCASE: 'identifiedVia'
};

/**
 * Maps identification filter value (from IDENTIFICATION_FILTER_VALUES) to the key
 * used in enabledIdentificationMethods (derived from org level settings).
 * ROOT and USER_MODIFIED have no org setting and are always enabled.
 */
const FILTER_VALUE_TO_ORG_KEY = {
  BINARY_FINGERPRINT: 'binaryFingerprint',
  KERNEL_MODULE: 'kernelModule',
  CURATED_HASH: 'curatedHash',
  LEGACY_HASH: 'legacyHash',
  LIBRARY_VERSION: 'libraryVersion',
  LIBRARY_NAME: 'libraryName',
  PACKAGE_MANIFEST: 'packageManifest',
  PE_METADATA: 'peMetaData',
  ROOT: null,
  SIGNATURE_DETECTION: 'signature',
  SYMBOL_INDEX: 'symbolIndex',
  USER_MODIFIED: null
};

export const isIdentificationMethodEnabled = (value, enabledIdentificationMethods) => {
  if (!enabledIdentificationMethods) return true;

  const orgKey = FILTER_VALUE_TO_ORG_KEY[value];
  if (orgKey === null) return true;

  return Boolean(enabledIdentificationMethods[orgKey]);
};

const isIdentificationFilter = filter => {
  return (
    (filter?.fieldName === IDENTIFIED_VIA_FIELD_NAMES.UPPERCASE ||
      filter?.columnName === IDENTIFIED_VIA_FIELD_NAMES.LOWERCASE) &&
    filter?.value
  );
};

const validateArrayValues = (values, enabledIdentificationMethods) => {
  const validValues = values.filter(value =>
    isIdentificationMethodEnabled(value, enabledIdentificationMethods)
  );
  return validValues.length === 0 ? null : validValues;
};

const validateConcatenatedValues = (value, enabledIdentificationMethods) => {
  const individualValues = value.split('&');
  const validIndividualValues = individualValues.filter(val =>
    isIdentificationMethodEnabled(val, enabledIdentificationMethods)
  );

  if (validIndividualValues.length === 0) {
    return null;
  } else if (validIndividualValues.length === individualValues.length) {
    return value;
  } else {
    return validIndividualValues.join('&');
  }
};

const validateSingleValue = (value, enabledIdentificationMethods) => {
  return isIdentificationMethodEnabled(value, enabledIdentificationMethods) ? value : null;
};

export const validateIdentificationFilters = (filters, enabledIdentificationMethods) => {
  if (!enabledIdentificationMethods) return filters;

  return filters
    ?.map(filter => {
      if (!isIdentificationFilter(filter)) {
        return filter;
      }

      let validValues;

      if (Array.isArray(filter.value)) {
        validValues = validateArrayValues(filter.value, enabledIdentificationMethods);
      } else if (typeof filter.value === 'string' && filter.value.includes('&')) {
        validValues = validateConcatenatedValues(filter.value, enabledIdentificationMethods);
      } else {
        validValues = validateSingleValue(filter.value, enabledIdentificationMethods);
      }

      if (validValues === null) {
        return null;
      }

      return {
        ...filter,
        value: validValues
      };
    })
    .filter(filter => filter !== null);
};
